export type CSSValue = number | string;

export const CSSValueWithPX = (value: CSSValue) => {
  return typeof value === 'string' ? value : `${value}px`;
};
